import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiaList } from "app/features/general/operativa/items/resumenchoferze/list/componentes/guias/list";
import { EntregasIncompletasList } from "./incompletas";
import { GuiasRechazadasList } from "./rechazadas";

export interface Props {
    model: models.VerificacionViajeZEDto;
}

const AEntregar = (x: Props) =>
    <div>
        <kea.Title titulo="Devolver a sucursal" />

        {kea.autogrid(6, [
            <kea.Panel title="Acuses firmados">
                <GuiaList value={x.model.AcusesFirmados} hideBusqueda />
            </kea.Panel>,
            <kea.Tab
                items={[
                    {
                        title: "Guias sin entregar",
                        body: <GuiaList value={x.model.GuiasEntregaIncompleta} hideBusqueda />
                    }, {
                        title: "Guias rechazadas",
                        body: <GuiasRechazadasList value={x.model.GuiasRechazadas} />
                    }, {
                        title: "Entregas incompletas",
                        body: <EntregasIncompletasList value={x.model.EntregasIncompletas} />
                    }
                ]}
            />
        ])}
    </div>;

const Entregado = (x: Props) =>
    <div>
        <kea.Title titulo="Guías entregadas" />
        <GuiaList value={x.model.GuiasEntregadas} />
    </div>

export class ListasVerificacion extends React.PureComponent<Props> {
    render() {
        return (
            <kea.Tab
                items={[
                    {
                        title: "Devolver a sucursal",
                        body: <AEntregar {... this.props} />
                    }, {
                        title: "Entregado",
                        body: <Entregado {... this.props} />
                    }
                ]}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesZE/verificar/listas/index.tsx